import { lazy } from 'react';
import i18next from 'i18next';

const DownForMaintenance = lazy(() => import('../../../pages/maintenance'));
const DashboardRoute = lazy(() => import('../wrappers/DashboardRoute'));
const NotFound = lazy(() => import('../../../pages/not-found'));
const Documentation = lazy(() => import('../../../Documentation'));

export const SERVICE_ROUTES = {
  downForMaintenance: {
    path: '/down-for-maintenance',
    exact: true,
    additional: {
      component: DownForMaintenance,
      protected: false,
    },
  },
  root: {
    path: '/',
    exact: true,
    additional: {
      component: DashboardRoute,
      title: i18next.t('titles:dashboard'),
      protected: true,
    },
  },
  documentation: {
    path: '/docs',
    exact: true,
    skipDashboardCommonLayout: true,
    additional: {
      component: Documentation,
      protected: true,
    },
  },
  notFound: {
    path: '/not-found',
    exact: true,
    additional: {
      component: NotFound,
      protected: true,
      title: i18next.t('titles:notFound'),
    },
  },
};
